export default {
	fillColor: '#F8E320',
	strokeColor: '#F8E320',
	strokeOpacity: 0.6,
	fillOpacity: 0.4,
	strokeWeight: 2,
	zIndex: 10,
}
